import { render, staticRenderFns } from "./PaymentProfileDetails.vue?vue&type=template&id=a15e083e&"
import script from "./PaymentProfileDetails.vue?vue&type=script&lang=ts&"
export * from "./PaymentProfileDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentProfileDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports